export const backNeuroText = {
  values: [
    { value: 'BackNeuro_nota', text: 'Ikke aktuelt', score: 0 },
    { value: 'BackNeuro_pow', text: 'Redusert kraft', score: 0 },
    {
      value: 'BackNeuro_sens',
      text: 'Redusert sensibilitet',
      score: 0,
    },
    {
      value: 'BackNeuro_reflex',
      text: 'Unormale reflekser',
      score: 0,
    },
  ],
};
